<template>
  <div id="modalLocalidad" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Localidad de beneficios</h5>
          <div class="acciones-modal">
            <button
              :disabled="!PuedeAplicar"
              @click="clickAplicar()"
              type="button"
              class="btn btn-success"
            >
              <font-awesome-icon :icon="Icons.ACEPTAR" />
            </button>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body">
          <!-- Radio button Filtrar por location -->
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault1"
              v-model="filterByLocation"
              :value="true"
            />
            <label class="form-check-label" for="flexRadioDefault1">
              Filtrar por localidad
            </label>
          </div>
          <SelectorLocalidad
            ref="selectorLocalidad"
            noCityString="Todas"
            v-on:localidad-cambiada="changedCity"
            v-on:provincia-cambiada="provinciaCambiada"
            class="selector"
          />         
          <!-- Radio button Mostrar todos -->
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault2"
              v-model="filterByLocation"
              :value="false"
            />
            <label class="form-check-label" for="flexRadioDefault2">
              Mostrar todos
            </label>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const bootstrap = require("bootstrap");

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapState } from "vuex";

import { Icons as IconConstants } from "../../constants";
import SelectorLocalidad from "../util/SelectorLocalidad";
import { Api } from "../../api";
import LocalStorageKeys from "../../data/localStorageKeys";
import { storeMutations } from "../../store";

const EVENTO_APLICADO = "aplicado";
/** Cuando se cerró el modal */
const EVENTO_CERRADO = "cerrado";

export default {
  components: {
    FontAwesomeIcon,

    SelectorLocalidad,
  },
  data() {
    return {
      modal: null,
      filterByLocation: true,
      currentProvince: null,
      currentCity: null,
    };
  },
  computed: {
    /**Constantes de iconos */
    // Se hace este trabajito de definirlo en computed para que sea tomado como que se usa y no tire warnings
    Icons() {
      return IconConstants;
    },
    PuedeAplicar() {
      return !this.filterByLocation || this.currentProvince != null;
    },
    // Computed properties de vuex
    // Datos compartidos en toda la app
    ...mapState({
      location: (state) => state.location,
    }),
  },

  mounted() {
    this.load();

    const opcionesModal = {};
    this.modal = new bootstrap.Modal(
      document.getElementById("modalLocalidad"),
      opcionesModal
    );
  },
  methods: {
    // Métodos externos (llamados desde afuera)
    EventoAbrir() {
      this.abrir();
    },

    // Métodos internos
    abrir() {
      // Cargar valor inicial para que queden bien los radio buttons      
      this.filterByLocation = this.location != null;
      this.modal.show();
    },

    load() {
      const lastLocationJson = localStorage.getItem(LocalStorageKeys.location);

      // Si hay JSON es porque ya se guardó algo anteriormente en el localStorage
      if (lastLocationJson) {
        // Convertir el json a objeto para poder trabajar
        const lastLocation = JSON.parse(lastLocationJson);

        // Si no tiene filterByLocation es porque se eligió "Mostrar todos"
        if (lastLocation.filterByLocation) {
          // Solo guardar una localización cuando se había elegido una,
          // en caso contrario se deja en null, lo que hace que no se filtre por una localización
          this.saveLocation(lastLocation);
        }
      }
      // Si no hay localización guardada, buscar la ciudad del usuario automáticamente
      else {
        Api.Localidad.getByIp()
          .then((response) => {
            const lista = response.data;

            if (lista && lista.length) {
              // Por ahora se toma la primera de la lista, en un futuro se podría dar a elegir al usuario
              const city = lista[0];

              this.saveLocation({ city });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    saveLocation(location) {
      location.filterByLocation = true;

      this.$refs.selectorLocalidad.changeLocation(
        location.city,
        location.province
      );

      this.storeLocation(location);

      // Guardar localización en localStorage
      localStorage.setItem(LocalStorageKeys.location, JSON.stringify(location));
    },

    cerrar() {
      this.$emit(EVENTO_CERRADO);
      this.modal.hide();
    },
    clickAplicar() {
      if (this.filterByLocation) {        
        this.saveLocation({
          city: this.currentCity,
          province: this.currentProvince,
        });
      } else {
        this.limpiar();
      }

      this.$emit(EVENTO_APLICADO);
      this.cerrar();
    },
    storeLocation(location) {
      this.$store.commit(storeMutations.changeLocation, location);
    },
    /** Limpia localización en vuex y en localStorage */
    limpiar() {
      this.$refs.selectorLocalidad.changeLocation(null, null);
      this.storeLocation(null);

      // Guardar un objeto vacío en la key de localización, esto indica que se seleccionó "mostrar todos"
      // Es importante que lo guardado esté en formato JSON ya que luego se parsea al cargar
      localStorage.setItem(LocalStorageKeys.location, "{}");
    },
    changedCity(city) {
      this.currentCity = city;
      this.filterByLocation = true;
    },
    provinciaCambiada(provincia) {
      this.currentProvince = provincia;
      this.filterByLocation = true;
    },
  },
};
</script>
<style scoped>
.actual span {
  margin-right: 5px;
}

.cambiar {
  width: 100%;
  display: flex;
  justify-content: center;
}

.cambiar .acciones {
  display: flex;
  justify-content: space-between;
}

.modal-body {
  text-align: left;
}

.selector {
  margin-left: 25px;
  margin-right: 5px;
  padding-bottom: 15px;
}
</style>